import useGetBrandsWithPurchasersReport from '../hooks/useGetBrandsWithPurchasersReport'
import {BrandReportContext} from '../context'
import {Pagination} from '../../../utils/pagination'
import {KTCard} from '../../../_metronic/helpers'
import BrandReportHeader from '../sections/header/BrandReportHeader'
import BrandReportTable from '../sections/table/BrandReportTable'
import {useGetBrandsDropdown} from '../hooks/useGetBrandsDropdown'
import {useGetPurchasersDropdown} from '../hooks/useGetPurchasersDropdown'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
import useGetProfitTrend from '../hooks/useGetProfitTrend'

function BrandReport() {
  const {
    reportData,
    pagination,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    onDateChange,
    onChangeBrandFilter,
    onChangePurchaserFilter,
    onDownloadCSV,
  } = useGetBrandsWithPurchasersReport()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('brand')

  const {brands, isBrandsLoading} = useGetBrandsDropdown()

  const {isPurchasersLoading, purchasers} = useGetPurchasersDropdown()

  const {
    profitTrendChartData,
    kpiData: profitTrendKpiData,
    weeklyBreakdownData: profitTrendWeeklyBreakdownData,
    isLoading: isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useGetProfitTrend('brand')

  const contextValue = {
    reportData,
    pagination,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    onDateChange,
    onChangeBrandFilter,
    onChangePurchaserFilter,
    onDownloadCSV,
    brands,
    isBrandsLoading,
    purchasers,
    isPurchasersLoading,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,

    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  }

  return (
    <KTCard>
      <BrandReportContext.Provider value={contextValue}>
        <BrandReportHeader />
        <BrandReportTable />
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </BrandReportContext.Provider>
    </KTCard>
  )
}

export default BrandReport
